export const list = {
  table: {
    quantity: 'Quantity',
    createdAt: 'Created At',
  },
  pageHeader: {
    title: 'Tank Histories',
    tankTitle: 'Input History',
    new: 'Create New',
  },
}
